import Navbar from './index.vue'

Navbar.install = Vue => {
  Vue.component(Navbar.name, Navbar)
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/navbar/index.js